"use client";

import { createContext, useContext } from "react";

/**
 * /my 좌측 사이드바 "추가 슬롯(outlet)" 컨텍스트 (JCG-2060).
 *
 * `my/MyLayoutClient.tsx` 가 데스크탑 셸 좌측 슬롯(customLeftSlot)에 글로벌 탭 네비(desktopNav)를
 * portal 하면서, 그 **아래**에 빈 `<div ref>` 를 함께 그려 그 DOM 노드를 이 컨텍스트로 내려준다.
 * 페이지(예: error-notes)는 `useMyLeftExtras().extrasSlot` 에 자기 컨트롤을 createPortal 한다.
 *
 * ArticleShell 의 슬롯 메커니즘과 동형(부모가 DOM 노드를 ref-콜백 state 로 잡아 context 로 제공,
 * 자식이 그 노드에 portal). 두 컴포넌트가 같은 슬롯에 각자 portal 하면 DOM 순서가 비결정적이라
 * (nav/extras 상하 뒤집힘) 회귀가 생기는데, layout 이 `<>{nav}<div/></>` 단일 portal 로 그려
 * 순서를 고정(nav 위 · extras 아래)하고 자식은 extras 노드에만 portal 하므로 순서가 결정적이다.
 *
 * Provider 가 없거나 셸 밖(모바일/클래식)이면 `extrasSlot` 은 null → 페이지가 본문 폴백으로 표시.
 */
export interface MyLeftExtrasContextValue {
  extrasSlot: HTMLElement | null;
}

const MyLeftExtrasContext = createContext<MyLeftExtrasContextValue>({
  extrasSlot: null,
});

export const MyLeftExtrasProvider = MyLeftExtrasContext.Provider;

export const useMyLeftExtras = (): MyLeftExtrasContextValue =>
  useContext(MyLeftExtrasContext);
